export class ConfirmationStripeModal
    {
        constructor(    public closestatus: boolean,     // True = Successful Stripe Payment
                        public paymentType: number,      // 1 = Default
                        public paymentamt: number,       // Credit Card Payment
                        public serviceperc: number,      // 0 - Non Applicable
                        public customeremail: string,    // Email
                        public customerpassword: string, // password
                        public eventname: string,        // event name
                        public eventid: string           // eventid     
                    ) 
            { 

                
            }
    }